import { gql, TypedDocumentNode, useQuery } from '@apollo/client';
import { AssignedPermission, GetPermissionsQuery, GetPermissionsQueryVariables } from '../../generated/graphql';

export const permissionsQuery: TypedDocumentNode<GetPermissionsQuery, GetPermissionsQueryVariables> = gql`
  query GetPermissions {
    permissions {
      id
      permissionId
      granted
    }
  }
`;

export interface UsePermissionsResults {
  permissions: readonly AssignedPermission[];
  loading: boolean;
}

export function usePermissions(): UsePermissionsResults {
  const { data, loading } = useQuery(permissionsQuery, {});
  return { permissions: data?.permissions ?? [], loading };
}
